import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "md:px-4" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-3 w-full" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "flex justify-end gap-2 w-full" }

export function render(_ctx, _cache) {
  const _component_PopupMainNavbar = _resolveComponent("PopupMainNavbar")
  const _component_PopupPromotionNavbar = _resolveComponent("PopupPromotionNavbar")
  const _component_Image = _resolveComponent("Image")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PopupMainNavbar),
    _createVNode(_component_PopupPromotionNavbar),
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-xl text-gray-800 text-start font-extrabold my-3" }, "โปรโมชั่นทั้งหมด", -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotionList, (promotion, index) => {
          return (_openBlock(), _createBlock(_component_Card, {
            key: index,
            pt: { root: 'bg-[#ffffffcf]! border-4! border-[#ff8a1f]!', body: 'p-1!' }
          }, {
            content: _withCtx(() => [
              _createVNode(_component_Image, {
                src: promotion.imgURL,
                alt: promotion.promotionName,
                preview: "",
                pt: { root: 'overflow-hidden rounded-lg' }
              }, null, 8 /* PROPS */, ["src", "alt"])
            ]),
            footer: _withCtx(() => [
              _createVNode(_component_Button, {
                onClick: $event => (_ctx.clickBtnDialog(promotion)),
                label: "รายละเอียด",
                size: "small",
                class: "w-full bg-[#753a13]! border-0!"
              }, null, 8 /* PROPS */, ["onClick"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.visible) = $event)),
      modal: "",
      header: _ctx.selectedPromotion?.promotionName,
      style: { width: '25rem' }
    }, {
      default: _withCtx(() => [
        (_ctx.selectedPromotion?.imgURL)
          ? (_openBlock(), _createBlock(_component_Image, {
              key: 0,
              src: _ctx.selectedPromotion.imgURL,
              alt: _ctx.selectedPromotion.promotionName,
              pt: { root: 'overflow-hidden rounded-lg' },
              class: "block mb-3"
            }, null, 8 /* PROPS */, ["src", "alt"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("p", {
          class: "text-xs text-pretty text-gray-600 mb-5",
          innerHTML: _ctx.selectedPromotion?.description || 'ไม่มีคำอธิบาย'
        }, null, 8 /* PROPS */, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createVNode(_component_Button, {
            type: "button",
            label: "รับโปรโมชั่น",
            onClick: _ctx.handleTakePromotion,
            class: "bg-[#753a13]! text-white! border-2 border-[#f0a241]! hover:text-white! w-full",
            disabled: !!_ctx.msgError
          }, null, 8 /* PROPS */, ["onClick", "disabled"]), [
            [
              _directive_tooltip,
              {
								value: _ctx.msgError,
								pt: {
									text: 'text-[12px]!',
								},
							},
              void 0,
              { top: true }
            ]
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible", "header"])
  ]))
}